import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import ButtonSpinner from './button-spinner.vue';
import {
    helpers,
    required,
} from 'vuelidate/lib/validators';
Vue.use(Vuelidate);

import { getCustomerRegisterUrl, xhrRequestConfig } from '../utils/api';

const API_URL = getCustomerRegisterUrl();

const emailValidation = helpers.regex('emailValidation', /^[a-zA-Z0-9.!#$%&’*/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/);

export default {
    components: {
        ButtonSpinner
    },

    data() {
        return {
            errors: {
                title: null,
                serverMessages: []
            },
            isSubmitting: false,
            form: {
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                accepts_marketing: false
            }
        }
    },

    computed: {
        email() {
            return this.form.email;
        }
    },

    validations() {
        return {
            form: {
                first_name: {
                    required
                },
                last_name: {
                    required
                },
                email: {
                    required,
                    emailValidation
                },
                password: { 
                    required,
                    // minLength: minLength(8),
                    // valid: function(value) {
                    //     const containsUppercase = /[A-Z]/.test(value);
                    //     const containsLowercase = /[a-z]/.test(value);
                    //     // const containsNumber = /[0-9]/.test(value);
                    //     const containsSpecial = /[#?!@$%^&*-]/.test(value);
                    //     return containsUppercase && containsLowercase && containsSpecial;
                    //   }
                }
            }
        }
    },

    methods: {
        submitForm() {
            this.isSubmitting = true;
            this.$v.$touch();

            if (this.$v.$error) {
                window.scrollTo(0,0);
                this.isSubmitting = false;
            } else {
                this._postForm();
            }
        },

        _postForm() {
            axios.post(API_URL, this.form, xhrRequestConfig).then(({ data }) => {
                if (!data.success) {
                    window.scrollTo(0,0);
                    this.errors.title = error.response.data.message;
                    this.errors.serverMessages = Object.values(error.response.data.reasons).flat(1);
                    this.isSubmitting = false;
                } 
                else if (!!data.success) {
                    this.$refs.login.click();
                }

            }).catch((error) => {
                // console.log("??", error.response)
                if (error.response?.data) {
                    window.scrollTo(0,0);
                    this.errors.title = error.response.data.message;
                    this.errors.serverMessages = Object.values(error.response.data.reasons).flat(1);
                }
                this.isSubmitting = false;
            });
        }
    }
}